import { useEffect, useState } from "react";
import {
  EntryType,
  getTournamentUserHistory,
  ParticipantHistoryDto,
  PaymentMethod,
} from "../../../../../../api/tournament-participant";
import { PaginationWrapper } from "../../../../../../component/CommonTable";
import PopupPagination from "../../../../../../component/Pagination/popupPagination";
import { formatDate } from "../../../../../../utils/date";
import { useDialogPayTypes } from "../../hooks/useDialogPayTypes";
import {
  MemberHistoryWrapper,
  MemberHistoryHeader,
  MemberHistoryInfoHeader,
  MemberHistoryHeaderRow,
  MemberHistoryInfoHeaderPay,
  MemberHistoryListWrapper,
  MemberHistoryListItem,
} from "./style";
import { Title } from "../../../../../../styles/page";
import MoreInfo from "../more";
import { useParticipantContext } from "../../hooks/participant-context";
import { useControllerContext } from "../../../../hooks/controller-context";
import { Const } from "../../../../../../common/const/const";

export const ControllerSitInMemberHistory = () => {
  const { setIsHistoryPopup, handleReEntryDelete, selectedMember } =
    useParticipantContext();
  const { data } = useControllerContext();
  const [allList, setAllList] = useState<ParticipantHistoryDto[]>([]);
  const [list, setList] = useState<ParticipantHistoryDto[]>([]);
  const [totalLength, setTotalLength] = useState<number>(0);
  const [totalPay, setTotalPay] = useState<number>(0);
  const [isHover, setIsHover] = useState<number>(0);
  const [totalPage, setTotalPage] = useState<number>(0);
  const [currentPage, setCurrentPage] = useState<number>(1);
  const {
    dialogPayType,
    resetDialogPayType,
    handleSetPaymentValues,
    handleDialogTypeSet,
  } = useDialogPayTypes();

  const getData = async () => {
    if (!data || !selectedMember) return;
    try {
      const res = await getTournamentUserHistory(
        selectedMember.memberId,
        data.id,
      );
      setTotalLength(res.length);
      const sum = res.reduce((sum, curr) => (sum += handlePayAmount(curr)), 0);
      setTotalPay(sum);
      setAllList(res);
    } catch (e: any) {
      console.log(e);
    }
  };
  useEffect(() => {
    getData();
  }, []);

  const onPageChange = async (nextPage: number) => {
    setCurrentPage(nextPage);
  };

  useEffect(() => {
    setTotalPage(Math.max(1, Math.ceil(allList.length / 10)));
    setList(allList.slice((currentPage - 1) * 10, currentPage * 10));
  }, [currentPage, allList]);

  // 자세히 보기
  const handleMore = (item: ParticipantHistoryDto | null) => {
    if (!item) {
      let cash = 0;
      let card = 0;
      let point = 0;
      let bank = 0;
      let discount = 0;
      let seed = 0;
      allList.forEach((item) => {
        for (const payment of item.participantPaymentMethod) {
          switch (payment.paymentMethod) {
            case PaymentMethod.CARD:
              card += payment.amount;
              break;
            case PaymentMethod.CASH:
              cash += payment.amount;
              break;
            case PaymentMethod.BANK_TRANSFER:
              bank += payment.amount;
              break;
            case PaymentMethod.DISCOUNT:
              discount += payment.amount;
              break;
            case PaymentMethod.POINTS:
              point += payment.amount;
              break;
            case PaymentMethod.SEED:
              seed += payment.amount;
              break;
          }
        }
      });

      handleDialogTypeSet(PaymentMethod.BANK_TRANSFER, bank);
      handleDialogTypeSet(PaymentMethod.CARD, card);
      handleDialogTypeSet(PaymentMethod.CASH, cash);
      handleDialogTypeSet(PaymentMethod.SEED, seed);
      handleDialogTypeSet(PaymentMethod.POINTS, point);
      handleDialogTypeSet(PaymentMethod.DISCOUNT, discount);
      setIsHover(-1);
      return;
    }

    handleSetPaymentValues(item);
    setIsHover(item.id);
  };

  const handleMoreOut = () => {
    resetDialogPayType();
    setIsHover(0);
  };

  // 결제 금액 총 합
  const handlePayAmount = (item: ParticipantHistoryDto) => {
    if (
      item.participantPaymentMethod.some(
        (pay) => pay.paymentMethod === PaymentMethod.SEED,
      )
    ) {
      let result = 0;
      item.participantPaymentMethod.forEach((pay) => {
        if (pay.paymentMethod !== PaymentMethod.SEED) {
          result += pay.amount;
        } else {
          result += pay.amount * Const.SEED_RATE;
        }
      });
      return result;
    }
    return item.paymentAmount;
  };

  const getEntryTypeText = (item: ParticipantHistoryDto) => {
    switch (item.entryType) {
      case EntryType.BUY_IN:
        return "엔트리";
      case EntryType.RE_BUY:
        return "리엔트리";
      case EntryType.ADD_ON:
        return `애드온(${item.isCount ? "Y" : "N"})`;
    }
  };

  const handleDeleteClick = async (id: number) => {
    try {
      await handleReEntryDelete(id);
    } catch (e) {
    } finally {
      getData();
    }
  };

  return (
    <MemberHistoryWrapper>
      <MemberHistoryHeader>
        <Title>{selectedMember?.nickname}님 이용 내역 목록</Title>
        <div className="back" onClick={() => setIsHistoryPopup(false)}>
          <img src="/image-web/solution/close.svg" alt="close" />
        </div>
      </MemberHistoryHeader>
      <MemberHistoryInfoHeader>
        <div>
          총 참여 횟수(엔트리/리엔트리/애드온)
          <span> - {totalLength}</span>
        </div>
        <MemberHistoryHeaderRow>
          <MemberHistoryInfoHeaderPay>
            <div>
              총 결제 금액 : <span>{totalPay.toLocaleString()}원</span>
            </div>
            <div
              className="more"
              onMouseOver={() => handleMore(null)}
              onMouseOut={() => handleMoreOut()}
            >
              <img src="/image-web/solution/more.png" alt="자세히 보기" />
              {isHover === -1 && (
                <MoreInfo
                  name="총 결제 내역"
                  dialogPayType={dialogPayType}
                />
              )}
            </div>
          </MemberHistoryInfoHeaderPay>
        </MemberHistoryHeaderRow>
      </MemberHistoryInfoHeader>
      <MemberHistoryListWrapper>
        {list.map((item, index) => (
          <MemberHistoryListItem key={index}>
            <div className="a">
              {formatDate(item.createdAt.toString(), true)}
              <br />
              (LV {item.level})
            </div>
            <div className="b">
              {handlePayAmount(item).toLocaleString()}원
              <div
                className="more"
                onMouseOver={() => handleMore(item)}
                onMouseOut={() => handleMoreOut()}
              >
                <img src="/image-web/solution/more.png" alt="자세히 보기" />
                {isHover === item.id && (
                  <MoreInfo
                    name="결제 내역"
                    dialogPayType={dialogPayType}
                    addStack={item.addStack}
                  />
                )}
              </div>
            </div>
            <div className="item">{getEntryTypeText(item)}</div>
            <div className="item" onClick={() => handleDeleteClick(item.id)}>
              {item.entryType !== "BUY_IN" && <span>삭제</span>}
            </div>
          </MemberHistoryListItem>
        ))}
      </MemberHistoryListWrapper>
      {totalPage > 1 && (
        <PaginationWrapper>
          <PopupPagination
            currentPage={currentPage}
            totalPages={totalPage}
            onPageChange={onPageChange}
          />
        </PaginationWrapper>
      )}
    </MemberHistoryWrapper>
  );
};
